import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../../shared-component/header/Header';

const LayoutComponent = () => {

    return (
        <React.Fragment>
            <Header />
            <Outlet />
        </React.Fragment>
    )
}

export default LayoutComponent;